import { FormattedMessage, useIntl } from 'react-intl';

import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import { SEARCH_STATE_PARAMS } from '@xing-com/crate-jobs-constants';
import { useSearchState } from '@xing-com/crate-jobs-hooks';

import { SINCE_PERIOD_KEY } from '../../../../helpers';
import { Tag } from '../applied-filters.styles';

export const TimeFrameTag: React.FC = () => {
  const { formatMessage } = useIntl();
  const { sincePeriod } = useSearchState();
  const { deleteSearchParameter } = useSearchParameter();

  if (!sincePeriod) {
    return null;
  }

  const handleOnClick = (): void => {
    deleteSearchParameter(SEARCH_STATE_PARAMS.sincePeriod, { replace: false });
  };

  const copy = SINCE_PERIOD_KEY[sincePeriod];
  const ariaLabel = formatMessage(
    { id: 'JOBS_SEARCH_FILTERS_DELETE_FILTER_A11Y' },
    {
      variable_1: formatMessage({
        id: copy,
      }),
    }
  );

  return (
    <Tag onClick={handleOnClick} aria-label={ariaLabel}>
      <FormattedMessage id={copy} />
    </Tag>
  );
};
